import React, {useContext} from 'react';
import Colors from "../../../assets/colors/Colors";
import {FlexedDiv, RankingsNavbarDiv, RankingsTitleDiv, RowDivF1} from "../../styledComponents/CustomStyledComponents";
import {RankingsAndLevelsMapContext} from "../../../contexts/RankingsAndLevelsMapContext";
import {RankingsAndLevelsContext} from "../../../contexts/RankingsAndLevelsContext";
import BackComponent from "../../backComponent/BackComponent";
import Constants from "../../../data/Constants";
// @ts-ignore
import {Link as RouterLink} from "react-router-dom";
import {useTranslation} from "react-i18next";

const Separator: React.FC = () => {
    return (
        <div style={{display: 'flex', flexDirection: 'row'}}>
            <div style={{flex: 0.15}} />
            <div style={{flex: 0, borderLeft: '1px solid', margin: 'auto', height: 30}} />
            <div style={{flex: 0.15}} />
        </div>
    );
};

const CountryNavbar: React.FC<{backRoute: string}> = ({backRoute}) => {
    // @ts-ignore
    const { country } = useContext(RankingsAndLevelsMapContext);
    // @ts-ignore
    const { isLife } = useContext(RankingsAndLevelsContext);
    const { t } = useTranslation();
    return (
        <RankingsNavbarDiv>
            <RowDivF1 style={{justifyContent: "space-between"}}>
                <RouterLink to={Constants.routes.rankings}>
                    <RankingsTitleDiv isLife={isLife} className='title'>
                        {t('countryContainer.title')}
                    </RankingsTitleDiv>
                </RouterLink>
                <Separator />
                <RankingsTitleDiv isLife={isLife} >{country}</RankingsTitleDiv>
                <Separator />
                <BackComponent
                    backRoute={backRoute}
                    label={t('back')}
                    customStyle={{justifyContent: 'center', alignItems: 'center', display: 'flex'}}
                    backColor={isLife ? Colors.fontWhite: Colors.fontGray}
                />
            </RowDivF1>
            <FlexedDiv flexValue={2}/>
        </RankingsNavbarDiv>
    )
};

export default CountryNavbar;
